module.exports = __webpack_public_path__ + "img/glm_gbt805_1988.prt.8ac6bfb0.jpg";